import { getJwtPayload } from './get'

export const isExpiredToken = (token: string) => {
  const { exp } = getJwtPayload(token)

  const today = Date.now()
  return today > Number(exp) * 1000
}
